import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";

export default function NotFound() {
  return (
    <>
      <Header />
      <main className="min-h-screen flex items-center justify-center pt-24">
        <div className="text-center">
          <div className="font-mono-ui text-[10px] tracking-[0.3em] text-[#A855F7] uppercase mb-4">404</div>
          <h1 className="font-display text-6xl md:text-8xl uppercase tracking-tighter text-white">
            Kayıp Kadraj
          </h1>
          <p className="mt-6 text-white/60 max-w-md mx-auto">
            Aradığınız sayfa artık bu ekranda değil.
          </p>
          <Link data-testid="404-home" to="/" className="btn-primary mt-8 inline-flex">
            Anasayfa
          </Link>
        </div>
      </main>
    </>
  );
}
